import React, { useRef, useState, useEffect } from "react";
import PageEditor from "../PageEditor/PageEditor";
import "./customtext.css";
import mixins from "../../app-services/mixins";
import { readUrl } from "../PageEditor/support";
import PreInfo from "./PreInfo";
import { withRouter } from "../../app-services/lib/router-compat";
import { Button } from "@mui/material";
// Import Pages
import FrontPage from "./frontpage.txt";
import Pageone from "./pageone.txt";
import Pagetwo from "./pagetwo.txt";

export function Costomtext(props) {
  const BOOKID = props.match.params.id;
  const book = props.store.book.customCharacter;
  const selfRef = useRef(null);
  if (!selfRef.current) {
    selfRef.current = {};
  }
  const self = selfRef.current;
  self.BOOKID = BOOKID;
  self.props = props;

  const [state, setStateRaw] = useState(() => ({
      pageStyle: {
        position: "relative",
        minHeight: "197mm",
        height: "197mm",
        width: "130mm",
        maxWidth: "130mm",
      },
      staticPages: {
        frontpage: FrontPage,
        pageone: Pageone,
        pagetwo: Pagetwo
      },
      savedBook: {},
      bolierplates: {},
      svgs: {},
      pages: [
        {
          pagetype: "fullimage",
          contentSize: 200,
          name: `frontpage`,
          label: `1`,
          content: book && book[`frontpage`],
        },
        {
          pagetype: "fullimage",
          contentSize: 200,
          name: `pageone`,
          label: `2`,
          content: book && book[`pageone`],
        },
        {
          pagetype: "fullimage",
          contentSize: 200,
          name: `pagetwo`,
          label: `3`,
          content: book && book[`pagetwo`],
        },
      ],
  }));

  self.state = state;
  self.setState = (update, callback) => {
    setStateRaw((prev) => {
      const next = typeof update === "function" ? update(prev) : { ...prev, ...update };
      return next;
    });
    if (callback) setTimeout(callback, 0);
  };
  initialConstruct.bind(self)("HandPrint", props);

  self.getContent = (book, page) => {
    let ele = mixins.getDataNode(book);
    const handprintPreInfo = self.props.store?.book?.handprintPreInfo;
    const answer = handprintPreInfo?.answer;
    const handprints = handprintPreInfo?.handprints;
    //console.log(page);
    let friend_name = ele.querySelector("#friend_name");
    if (friend_name && answer && answer.friend_name) {
      friend_name.innerText = answer.friend_name;
    }

    let adult_name = ele.querySelector("#your_name");
    if (adult_name && answer && answer.your_name) {
      adult_name.innerText = answer.your_name;
    }
    book = ele.innerHTML;
    return book;
  };

  self.getLatestBook = () => {
    const handprintPreInfo = self.props.store?.book?.handprintPreInfo;
    return new Promise((resolve, reject) => {
      api
        .getUpdatedSelfBook({
          sessionId: localStorage.getItem("sessionID") || null,
          type: "handprint",
        })
        .then((responce) => {
          if (responce && responce.data) {
            let payload = responce.data;
            if (Object.entries(handprintPreInfo).length === 0) {
              self.setStore(
                "book.handprintPreInfo",
                JSON.parse(payload.attributes || "{}")
              );
            }
            self.setState((prev) => ({
              ...prev,
              savedBook: payload,
            }));
            resolve(payload);
          } else {
            resolve(self.state.savedBook);
          }
        })
        .catch(reject);
    });
  };

  self.onSave = (payload, saveSelf) => {
    const saveBOOKID = saveSelf.BOOKID;
    const { savedBook } = saveSelf.state;
    let history = saveSelf.history;
    const handprintPreInfo = saveSelf.props.store?.book?.handprintPreInfo;
    return new Promise((resolve, reject) => {
      if (savedBook && savedBook.id) {
        api
          .updateSelfPublish(
            {
              bookId: saveBOOKID,
              savedBook: JSON.stringify(payload),
              option: "dynamic",
              sessionId: localStorage.getItem("sessionID") || null,
              type: "handprint",
              attributes: JSON.stringify(handprintPreInfo),
            },
            savedBook.id
          )
          .then((responce) => {
            mixins.checkLogin(history).then(() => {
              saveSelf
                .getLatestBook()
                .then((responce) => {
                  resolve(responce);
                })
                .catch(reject);
            });
          });
      } else {
        api
          .createSelfPublish({
            bookId: saveBOOKID,
            savedBook: JSON.stringify(payload),
            option: "dynamic",
            sessionId: localStorage.getItem("sessionID") || null,
            file: null,
            type: "handprint",
            attributes: JSON.stringify(handprintPreInfo),
          })
          .then((responce) => {
            mixins.checkLogin(history).then(() => {
              saveSelf
                .getLatestBook()
                .then((responce) => {
                  resolve(responce);
                })
                .catch(reject);
            });
          });
      }
    });
  };

  self.onUpdate = () => {};

  self.updateBoilerplate = () => {
    return new Promise((resolve, reject) => {
      let { staticPages } = self.state;
      let promises = Object.entries(staticPages).map(([key, url]) => {
        return new Promise((resolve, reject) => {
          readUrl(url)
            .then((responce) => resolve({ key, responce }))
            .catch(reject);
        });
      });
      Promise.all(promises)
        .then((responce) => {
          let bolierplates = responce.reduce(
            (o, n) => ({ ...o, [n.key]: n.responce }),
            {}
          );
          resolve(bolierplates);
        })
        .catch(reject);
    });
  };

  self.onProceed = () => {
    self.updateData();
  };

  self.updateChanges = (payload, modal) => {
    const handprintPreInfo = self.props.store?.book?.handprintPreInfo;
    let preInfo = handprintPreInfo || {};
    preInfo.answer = payload;
    preInfo.answer = payload;
    self.setStore("book.handprintPreInfo", preInfo);
    modal && modal.close();
    setTimeout(() => {
      self.updateData();
    }, 0);
  };

  self.uploadHanprints = (payload, modal) => {
    const handprintPreInfo = self.props.store?.book?.handprintPreInfo;
    let preInfo = handprintPreInfo || {};
    preInfo.answer = payload;
    self.setStore("book.handprintPreInfo", preInfo);
    modal && modal.close();
    setTimeout(() => {
      self.updateData();
    }, 0);
  };

  self.collectInfo = (closable = false) => {
    let onChange = (answer) => {};
    let modal = alert(
      (alertProps) => (
        <PreInfo
          closable={closable}
          alert={alertProps}
          id={self.BOOKID}
          onChange={(...arg) => onChange(...arg)}
          onSave={(...arg) => self.uploadHanprints(...arg)}
          onClose={(...arg) => self.uploadHanprints(...arg)}
        />
      ),
      "",
      "model",
      {
        footer: false,
        class: "",
        parentclass: "HandPrint",
        options: {},
      }
    );
  };

  self.updateData = () => {
    self.updateBoilerplate().then((bolierplates) => {
      self.getLatestBook().then((bookObj) => {
        let book = bookObj?.savedBook?.parse({}) || {};
        self.setState((prev) => ({
          ...prev,
          savedBook: bookObj,
          bolierplates: bolierplates,
          pages: prev.pages.map((o) => ({
            ...o,
            content: self.getContent(
              o.content || book[o.name] || bolierplates[o.name] || "",
              o
            ),
          })),
        }));
      });
    });
  };

  self.RightChildren = (childSelf) => {
    return () => (
      <Button
        className="edit"
        variant="outlined"
        onClick={() => {
            localStorage.setItem('customEdit', true);
            childSelf.collectInfo(true);
    } }
      >
        <i className="fa fa-edit"></i>
        <small>Edit</small>
      </Button>
    );
  };

  self.getNoticeMeesage = () => {
    let defaultmessage = "";
    let device = self.$store?.device;
    if (["mob", "small", "tab", "lap"].includes(device)) {
      defaultmessage +=
        "<br/><span style='font-size:12px; color:#cc3300; font-weight:400;'>Books Best view in Desktop version only</span>";
    }
    return defaultmessage;
  };

  useEffect(() => {
    let {
      match: {
        params: { genpdf, customBookId },
      },
    } = self.props;
    const handprintPreInfo = self.props.store?.book?.handprintPreInfo;
    const handprints = handprintPreInfo?.handprints;
    if (
      !handprintPreInfo ||
      !handprints ||
      (handprints && Object.keys(handprints).length <= 0 && !customBookId)
    ) {
      self.collectInfo();
    } else {
      self.updateData();
    }
  }, []);

  let noticeMessage = self.getNoticeMeesage();
  const { savedBook, pages, overlayStyle, pageStyle } = state;
  const { onSave, RightChildren } = self;

  return (
    <div className="customtext top-margin">
      <PageEditor
        pagePayload={pages}
        onSave={(...arg) => onSave(...arg, self)}
        charcount={100}
        lastPageNo={3}
        overlay={true}
        style={overlayStyle}
        leftTool={false}
        readonly={true}
        editbackground={false}
        RightChildren={RightChildren(self)}
        showCount={false}
        pageBordered={false}
        pageStyle={pageStyle}
        uploadplaceholder={false}
        nextmode={true}
        bookDetails={savedBook}
        message={noticeMessage}
      ></PageEditor>
    </div>
  );
}

export default connect(withRouter(Costomtext));
